<template>
  <div class="wrapper">
    <header class="header">
      <h3 class="heading">{{ __("Filters") }}</h3>
      <a href="#" class="close" @click.prevent="close">
        <i-icon name="cancel" />
      </a>
    </header>
    <main class="main">
      <div class="p-d-flex p-flex-column">
        <span>{{ __("Building") }}:</span>
        <p-vue-dropdown
          :options="this.filterOptions?.Buildings"
          :optionLabel="'Build'"
          :filter="this.filterOptions?.Buildings.length > 10"
          v-model="filters.Building"
          class="dropdown p-mt-2"
        >
          <template #value="{ value, placeholder}">
            <div class="inner p-d-flex p-jc-between">
              <span class="value">{{ value ? value.Build : placeholder }}</span>
              <span class="icon">
                <i-icon name="arrow" />
              </span>
            </div>
          </template>
        </p-vue-dropdown>
      </div>
      <div class="p-d-flex p-flex-column p-mt-4" v-if="!isKey">
        <span>{{ __("Type") }}:</span>
        <p-vue-dropdown
          :options="this.filterOptions?.Types"
          :optionLabel="'Name'"
          :filter="this.filterOptions?.Types.length > 10"
          v-model="filters.Type"
          class="dropdown p-mt-2"
        >
          <template #value="{ value, placeholder}">
            <div class="inner p-d-flex p-jc-between">
              <span class="value">{{ value ? value.Name : placeholder }}</span>
              <span class="icon">
                <i-icon name="arrow" />
              </span>
            </div>
          </template>
        </p-vue-dropdown>
      </div>
      <div class="p-d-flex p-flex-column p-mt-4">
        <span>{{ __("Storage Location") }}:</span>
        <p-vue-dropdown
          :options="this.filterOptions?.StorageLocations"
         
          :filter="this.filterOptions?.StorageLocations.length > 10"
          v-model="filters.StorageLocation"
          class="dropdown p-mt-2"
        >
          <template #value="{ value, placeholder}">
            <div class="inner p-d-flex p-jc-between">
              <span class="value">{{ value ? value : placeholder }}</span>
              <span class="icon">
                <i-icon name="arrow" />
              </span>
            </div>
          </template>
        </p-vue-dropdown>
      </div>
      <div class="p-d-flex p-flex-column p-mt-4" style="margin-right:8px">
        <label class="checkBoxDesign p-mb-2">
          {{ __("Also view delivered items") }}:
        </label>
        <p-vue-checkbox
          class="p-m-auto"
          :binary="true"
          v-model="filters.IsDelivered"
        />
      </div>
    </main>
    <div class="actions p-fluid">
      <p-vue-button
        class="p-button p-button-outlined p-button-rounded p-button-success"
        @click="filter"
      >
        <span class="p-button-text">{{ __("Filter") }}</span>
      </p-vue-button>
      <p-vue-button
        class="p-button p-button-outlined p-button-rounded p-button-success"
        @click="clearFilter"
      >
        <span class="p-button-text">{{ __("Unfilter") }}</span>
      </p-vue-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    close: {
      type: Function,
      default: () => false,
    },
    filterOptions: {},
    filterSelected: {},
    isKey:Boolean
  },
  emits: ["filter"],
  data() {
    return {
      filters: {},
    };
  },
  mounted() {
    this.filters = this.filterSelected;
  },
  methods: {
    filter() {
      this.$emit("filter", this.filters);
      this.close();
    },
    clearFilter() {
      this.filters = {};
      this.filter();
    },
  },
  computed: {
    ...mapState({
      userNum: (state) => state.api.workerID,
    }),
  },
};
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 95vh;
  max-height: 100vh;
}

.header {
  top: 0;
  z-index: 2;
  position: sticky;
  position: -webkit-sticky;
  background-color: white;
  padding: 20px;
    display: flex;
    justify-content: space-between;
}

.close {
  color: var(--color-primary);
}

.close .svg {
  width: 17px;
  height: 17px;
}

.heading {
  margin: 0;
  line-height: 1;
  font-size: 26px;
  font-weight: normal;
  color: var(--color-primary);
}

.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.actions {
  padding: 20px;
}

.actions:deep(button) {
  margin-bottom: 20px;
}

.icon:deep(.svg) {
  color: var(--color-success);
  width: 15px;
  height: 15px;
}

:deep(.p-selectbutton .p-highlight) {
  background-color: var(--color-success);
  border-color: var(--color-success);
}

:deep(.p-selectbutton .p-highlight:hover) {
  background-color: var(--color-success);
  border-color: var(--color-success);
}

:deep(.p-override-select-button) {
  width: 100%;
  margin-top: 10px;
}

:deep(.p-selectbutton.p-buttonset.p-component) {
  width: 100%;
  display: grid;
  grid-template-columns: 50% 50%;
}

:deep(.p-override-select-button .p-buttonset .p-button:first-of-type) {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

:deep(.p-override-select-button .p-buttonset .p-button:last-of-type) {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.status {
  display: grid;
  grid-template-columns: 75% 20%;
  justify-content: space-between;
  align-items: center;
}
</style>
